// =====================================
//
//   觀看樣板規格 Modal
//   Author: Gray
//   createtime: 2016 / 05 / 23
//   updatetime: 2016 / 05 / 23
//
// =====================================

window.InifECApp.directive('addTemplateToCart', ['$rootScope', '$stateParams', '$state', '$ngModal', 'TemplateService', 'ProductService', '$ProductFormatService',
    function($rootScope, $stateParams, $state, $ngModal, TemplateService, ProductService, $ProductFormatService) {

        var _dir = {};

        var controller = ['$scope', '$element', function($scope, $element) {

            // --------------------------------
            // [private] 打開 Modal
            // --------------------------------
            var openModal = function() {

                $ngModal.openModal('add-template-to-cart-modal');
                $element.find('.content').scrollTop(0);
            }

            // --------------------------------
            // [private] 關閉 Modal
            // --------------------------------
            var closeModal = function() {

                $ngModal.closeModal('add-template-to-cart-modal');
            }

            // --------------------------------
            // 選擇是否要修改樣板
            // --------------------------------
            var selectIsChangeTemplate = function(isChangeTemplate) {

                $scope.isChangeTemplate = isChangeTemplate;
            }

            // --------------------------------
            // 取得下載網址
            // --------------------------------
            var getDownloadUrl = function(url) {

                return url;
            }

            // --------------------------------
            // [private] reset
            // --------------------------------
            var reset = function() {

                $scope.isChangeTemplate = undefined;
                $scope.form.remark = undefined;
            }

            var getPdtClassList = function(orderitem) {

                if($scope.isLoading || $scope.isLoaded) {
                    return;
                }

                $scope.isLoading = true;
                ProductService.getPdtClassList().then(function(result) {
                    if(result) {

                        $scope.pdtClassList = $ProductFormatService.getPdtClassList('MODAL');

                        if(!$scope.pdtClassList || $scope.pdtClassList.length == 0) {
                            var _result = shallowCopy(result);

                            $scope.pdtClassList = $ProductFormatService.formatModalPdtClassList(_result);
                        }

                        getPdtClassListSuccess(orderitem);
                    }

                    $scope.isLoaded = true;
                    $scope.isLoading = false;
                }, function(error) {
                    $scope.isLoading = false;
                    $scope.isError = true;
                });
            }

            var getPdtClassListSuccess = function(orderitem) {

                if($scope.pdtClassList.length > 0) {
                    getOrderItem(orderitem);
                }
            }

            var getOrderItem = function(orderitem) {

                for(var i = 0; i < $scope.pdtClassList.length; i++) {

                    var mainPdtClass = $scope.pdtClassList[i];

                    for(var j = 0; j < mainPdtClass.pdtClasses.length; j++) {

                        var pdtClass = mainPdtClass.pdtClasses[j];

                        if(orderitem.pdtClass == pdtClass.pdtClass) {

                            // 複合商品找法不同
                            if(orderitem.complexidList && orderitem.complexidList.length > 0) {
                                if(getComplexOrderItem(orderitem, mainPdtClass, pdtClass)) {
                                    return;
                                }
                            } else {
                                for(var k = 0; k < pdtClass.products.length; k++) {
                                    var product = pdtClass.products[k];
                                    if(orderitem.productid == product.productid) {
                                        $scope.form.mainPdtClass = mainPdtClass;
                                        $scope.form.pdtClass = pdtClass;
                                        $scope.form.product = product;
                                        return;
                                    }
                                }
                            }                            
                        }
                    }
                }
            }

            var getComplexOrderItem = function(orderitem, mainPdtClass, pdtClass) {

                for(var i = 0; i < pdtClass.products.length; i++) {
                    var product = pdtClass.products[i];

                    if(product.complex && product.complex.productList && product.complex.productList.length > 0) {
                        for(var j = 0; j <  product.complex.productList.length; j++) {
                            var complexPdt = product.complex.productList[j];
                            if(orderitem.productid == complexPdt.productid) {
                                $scope.form.mainPdtClass = mainPdtClass;
                                $scope.form.pdtClass = pdtClass;
                                
                                var _product = shallowCopy(product);

                                complexPdt.name = _product.name;
                                complexPdt.complex = _product.complex;
                                complexPdt.isComplex = _product.isComplex;

                                $scope.form.product = complexPdt;
                                return true;
                            }
                        }
                    }
                }

                return false;
            }

            var changeMainPdtClass = function(mainPdtClass){
                if($scope.form.mainPdtClass == mainPdtClass){
                    return;
                }

                $scope.form.mainPdtClass = mainPdtClass;
                changePdtClass(mainPdtClass.pdtClasses[0]);
            }

            var changePdtClass = function(pdtClass) {
                if($scope.form.pdtClass == pdtClass) {
                    return;
                }

                $scope.form.pdtClass = pdtClass;
                changeProduct(pdtClass.products[0]);
            }

            var changeProduct = function(product) {
                if($scope.form.product == product) {
                    return;
                }

                $scope.form.product = product;
            }

            var init = function(orderitem) {

                if($scope.isLoaded){
                    getOrderItem(orderitem);
                    return;
                }

                getPdtClassList(orderitem);
            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_ADD_TEMPLATE_TO_CART_MODAL", function(event, data) {

                if(data) {
                    reset();

                    $scope.template = data.template;
                    $scope.orderitem = $scope.template.orderitem;
                    
                    selectIsChangeTemplate(false);

                    init($scope.orderitem);

                    openModal();
                }
            });

                
            /*==========================
                Members
            ==========================*/
            $scope.template;
            $scope.isChangeTemplate = undefined;

            $scope.isLoading = false;
            $scope.isLoaded = false;
            $scope.pdtClassList = [];
            $scope.orderitem = undefined;

            $scope.form = {
                mainPdtClass: undefined,
                pdtClass: undefined,
                product: undefined,
                changeTemplateRemark: undefined,
                isChangeTemplateRemarkEmpty: false,
            };

            /*==========================
                Methods
            ==========================*/
            $scope.changeMainPdtClass = changeMainPdtClass;
            $scope.changePdtClass = changePdtClass;
            $scope.changeProduct = changeProduct;
            $scope.selectIsChangeTemplate = selectIsChangeTemplate; // 選擇是否要修改樣板
            $scope.getDownloadUrl = getDownloadUrl; // 取得下載網址

            /*==========================
                init
            ==========================*/

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'partials/modal/add_template_to_cart.html';
        _dir.controller = controller;

        return _dir;
}]);